// import {
//   cibFacebook,
//   cibTwitter,
//   cibLinkedin,
//   cibFlickr,
//   cibTumblr,
//   cibXing,
//   cibGithub,
//   cibGoogle,
//   cibStackoverflow,
//   cibYoutube,
//   cibDribbble,
//   cibInstagram,
//   cibPinterest,
//   cibVk,
//   cibYahoo,
//   cibBehance,
//   cibReddit,
//   cibVimeo,
//   cibCcMastercard,
//   cibCcVisa,
//   cibCcStripe,
//   cibCcPaypal,
//   cibCcApplePay,
//   cibCcAmex,
//
//   cifUs, cifBr, cifIn, cifFr, cifEs, cifPl,
//
//   cilArrowBottom,
//   cilArrowRight,
//   cilArrowTop,
//   cilBan,
//   cilBasket,
//   cilBell,
//   cilCalculator,
//   cilCalendar,
//   cilCloudDownload,
//   cilChartPie,
//   cilCheck,
//   cilChevronBottom,
//   cilChevronTop,
//   cilCheckCircle,
//   cilCode,
//   cilCommentSquare,
//   cilCursor,
//   cilDrop,
//   cilDollar,
//   cilEnvelopeClosed,
//   cilEnvelopeOpen,
//   cilEuro,
//   cilGlobeAlt,
//   cilGrid,
//   cilFile,
//   cilJustifyCenter,
//   cilLaptop,
//   cilLayers,
//   cilLightbulb,
//   cilList,
//   cilLocationPin,
//   cilLockLocked,
//   cilMagnifyingGlass,
//   cilMediaPlay,
//   cilMenu,
//   cilMoon,
//   cilNotes,
//   cilOptions,
//   cilPencil,
//   cilPeople,
//   cilPuzzle,
//   cilSettings,
//   cilShieldAlt,
//   cilSpeech,
//   cilSpeedometer,
//   cilStar,
//   cilTask,
//   cilUser,
//   cilUserFemale,
//   cilUserFollow,
//   cilXCircle,
// } from '@coreui/icons'

import * as icon from '@coreui/icons';
export const iconsSet = Object.assign({}, icon)
//
// export const iconsSet = Object.assign(
//   {},
//   {
//     cilArrowBottom,
//     cilArrowRight,
//     cilArrowTop,
//     cilBan,
//     cilBasket,
//     cilBell,
//     cilCalculator,
//     cilCalendar,
//     cilCloudDownload,
//     cilChartPie,
//     cilCheck,
//     cilChevronBottom,
//     cilChevronTop,
//     cilCheckCircle,
//     cilCode,
//     cilCommentSquare,
//     cilCursor,
//     cilDrop,
//     cilDollar,
//     cilEnvelopeClosed,
//     cilEnvelopeOpen,
//     cilEuro,
//     cilGlobeAlt,
//     cilGrid,
//     cilFile,
//     cilJustifyCenter,
//     cilLaptop,
//     cilLayers,
//     cilLightbulb,
//     cilList,
//     cilLocationPin,
//     cilLockLocked,
//     cilMagnifyingGlass,
//     cilMediaPlay,
//     cilMenu,
//     cilMoon,
//     cilNotes,
//     cilOptions,
//     cilPencil,
//     cilPeople,
//     cilPuzzle,
//     cilSettings,
//     cilShieldAlt,
//     cilSpeech,
//     cilSpeedometer,
//     cilStar,
//     cilTask,
//     cilUser,
//     cilUserFemale,
//     cilUserFollow,
//     cilXCircle,
//   },
//   {
//     cifUs,
//     cifBr,
//     cifIn,
//     cifFr,
//     cifEs,
//     cifPl,
//   },
//   {
//     cibFacebook,
//     cibTwitter,
//     cibLinkedin,
//     cibFlickr,
//     cibTumblr,
//     cibXing,
//     cibGithub,
//     cibGoogle,
//     cibStackoverflow,
//     cibYoutube,
//     cibDribbble,
//     cibInstagram,
//     cibPinterest,
//     cibVk,
//     cibYahoo,
//     cibBehance,
//     cibReddit,
//     cibVimeo,
//     cibCcMastercard,
//     cibCcVisa,
//     cibCcStripe,
//     cibCcPaypal,
//     cibCcApplePay,
//     cibCcAmex,
//   },
// )
